// Library Class
import { Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
// Service Class
import { LocalStorageService } from './../../../../services/infrastructure/local-storage.service';
import { LoaderService } from './../../../../services/infrastructure/loader.service';
import { PrePayService } from './../../../../services/common/pre-pay.service';
import { ExcelService } from './../../../../services/infrastructure/excel.service';
// Class
import { PrepayFilter } from '../../../../models/PrepayFilter';
import { DashboardFilter } from '../../../../models/DashboardFilter';
import { MasterConstants } from '../../../../common/constants/master-constants';
import { PrepayDetailVM } from './../../../../models/PrepayDetailVM';
import { ConfirmDialogComponent } from './../../../../common/components/confirm-dialog/confirm-dialog.component';
import { Subscription } from 'rxjs';
import { CommonService } from '../../../../services/common/common.service';
import * as $ from 'jquery';

@Component({
  selector: 'app-prepay-landing',
  templateUrl: './prepay-landing.component.html',
  styleUrls: ['./prepay-landing.component.scss']
})
export class PrepayLandingComponent implements OnInit, OnDestroy {
  private subscription = new Array<Subscription>();

  headerYear: any;
  headerCompany = MasterConstants.US_COMPANYCODE;
  filterArray = [];
  productNameList: any = [];
  prePayTypeList: any = [];
  cropYearData: any = [];
  selectedValue: string;
  filterList: any;
  filterValueList = new Array();
  length = 0;
  pageSize = 50;
  pageIndex = 0;
  pending = 0;
  active = 0;
  pageSizeOptions: number[] = [5, 10, 25, 50];
  activePendingContractsList: any = [];
  closedContractsList: any = [];
  isEvolveAccountRestriction = false;
  validateEvolveData: any;
  filter: PrepayFilter = new PrepayFilter();
  contractPdf: any = [];
  accessTypeMode = false;
  accountList: any;
  dashboardFilter: DashboardFilter;
  selectedAccount: any;
  // set table header data
  searchTypeList: string[] = ['Account No', 'Account Name', 'Prepay Type'];

  @ViewChild('closedContractsTable', { read: MatSort }) closedContractsSort: MatSort;
  @ViewChild('closedContractsPaginator', { read: MatPaginator }) closedContractsPaginator: MatPaginator;

  @ViewChild('activePendingContractsTable', { read: MatSort }) activePendingContractsSort: MatSort;
  @ViewChild('activePendingContractsPaginator', { read: MatPaginator }) activePendingContractsPaginator: MatPaginator;

  // data souce list
  dataSourceList: any[];

  public activePendingContractsDataSource: MatTableDataSource<any>;
  public closedContractsDataSource: MatTableDataSource<any>;
  contractsColumns: string[] = ['contractNumber', 'cropYear', 'contractDescription', 'supplier', 'contractType', 'requestedDate', 'status', 'amountRequested', 'currentBalance', 'contextMenu'];
  activePendingFooterContractsColumns: string[] = ['contractNumber', 'cropYear', 'contractDescription', 'supplier', 'contractType', 'requestedDate', 'status', 'amountRequested', 'currentBalance', 'contextMenu'];
  closedFooterContractsColumns: string[] = ['contractNumber', 'cropYear', 'contractDescription', 'supplier', 'contractType', 'requestedDate', 'status', 'amountRequested', 'currentBalance', 'contextMenu'];
  tempDataList: any = [];

  constructor(private router: Router,
    private localStorageService: LocalStorageService,
    private loaderService: LoaderService,
    private prePayService: PrePayService,
    private toastrService: ToastrService,
    private excelService: ExcelService,
    private matDialog: MatDialog,
    private datePipe: DatePipe,
    private commonService: CommonService) {
    this.dashboardFilter = new DashboardFilter();
  }

  ngOnInit() {
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      this.validateEvolveData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
    }

    if (this.validateEvolveData != undefined) {
      const sessionData = this.validateEvolveData.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
      this.isEvolveAccountRestriction = sessionData.evolveAccountRestriction;
    }
    this.getCropYearData();
    this.loaderService.setLoaderStatus(true);
    this.clearAllData();
    this.getAccountData();

    this.accessTypeMode = false;
    setTimeout(x => {
      this.accessTypeMode = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.PREPAY, MasterConstants.USER_ACCESS.EDIT_FULL);
    }, 500);
  }

  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setPrepayPageHeight();
  }
  //setPrepayPageHeight() {
  //  const tableHeight = window.innerHeight - 100;
  //  $('.tableContainer').css('max-height', tableHeight + 'px');

  //}
  setPrepayPageHeight() {
    setTimeout(function () {
      const templateHeight = window.innerHeight - $('.search-box').outerHeight() - $('.mat-tab-header').outerHeight() - $('.fulfill-top-sec').outerHeight() - 220;
      $('.growertableContainer').css('max-height', templateHeight + 'px');
    }, 100);
  }

  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setPrepayPageHeight();
  }
  // Get account list
  getAccountData() {
    this.dashboardFilter.cropYear = this.headerYear;
    this.subscription.push(this.prePayService.getAccountList(this.dashboardFilter).subscribe(result => {
      this.accountList = result['accounts'];
      if (this.prePayService.selectedAccount) {
        this.selectedAccount = this.prePayService.selectedAccount;
        this.getActivePendingContractsList();
      } else {
        this.loaderService.setLoaderStatus(false);
      }
    }, error => {
      this.loaderService.setLoaderStatus(false);
    }));
  }

  // Get Active Pending Contracts list
  getActivePendingContractsList() {// data: any) {
    this.loaderService.setLoaderStatus(true);
    const data = {
      StartingCropYear: this.headerYear - 2001,
      CompanyNumber: this.headerCompany,
      Account: this.selectedAccount
    };

    this.subscription.push(this.prePayService.getActivePendingClosedContractsData(data).subscribe((results: any) => {
      if (results) {
        this.loaderService.setLoaderStatus(true);
        this.tempDataList = results;
        this.activePendingContractsList = results.filter(x => x.status === 'A' || x.status === 'P');
        if (this.activePendingContractsList.length === 0) {
          this.activePendingFooterContractsColumns = [];
        } else {
          this.activePendingFooterContractsColumns = ['contractNumber', 'cropYear', 'contractDescription', 'supplier', 'contractType', 'requestedDate', 'status', 'amountRequested', 'currentBalance', 'contextMenu'];
        }

        this.activePendingContractsDataSource = new MatTableDataSource(this.activePendingContractsList);
        this.activePendingContractsDataSource.sort = this.activePendingContractsSort;
        this.activePendingContractsDataSource.paginator = this.activePendingContractsPaginator;

        this.closedContractsList = results.filter(x => x.status === 'C');;
        if (this.closedContractsList.length === 0) {
          this.closedFooterContractsColumns = [];
        } else {
          this.closedFooterContractsColumns = ['contractNumber', 'cropYear', 'contractDescription', 'supplier', 'contractType', 'requestedDate', 'status', 'amountRequested', 'currentBalance', 'contextMenu'];
        }
        this.closedContractsDataSource = new MatTableDataSource(this.closedContractsList);
        this.closedContractsDataSource.sort = this.closedContractsSort;
        this.closedContractsDataSource.paginator = this.closedContractsPaginator;
        this.loaderService.setLoaderStatus(false);
      }
    }, error => {
      this.toastrService.error('Your prepay request failed, please call WinField United customer service at 855-494-6343');
      this.loaderService.setLoaderStatus(false);
    }));
  }
  // return count of active pending contracts
  getTotalContracts() {
    return this.activePendingContractsList.length;
  }
  // return count of closed contracts
  getClosedContracts() {
    return this.closedContractsList.length;
  }
  // return total of amount requested for active & pending contract
  getTotalAmountRequested() {
    return this.activePendingContractsList.map(t => t.amountRequested).reduce((acc, value) => acc + value, 0);
  }
  // return total of amount requested for active & pending contract
  getTotalCurrentBalance() {
    return this.activePendingContractsList.map(t => t.currentBalance).reduce((acc, value) => acc + value, 0);
  }
  // return count of closed account
  getPendingCount() {
    return this.activePendingContractsList.filter(t => t.status.toLocaleUpperCase() === 'P').length;
  }
  // return count of active account
  getActiveCount() {
    return this.activePendingContractsList.filter(t => t.status.toLocaleUpperCase() === 'A').length;
  }
  // return total of current balance closed contract
  getTotalClosedCurrentBalance() {
    return this.closedContractsList.map(t => t.currentBalance).reduce((acc, value) => acc + value, 0);
  }
  // return total of amount requested closed contract
  getTotalClosedContractAmountRequested() {
    return this.closedContractsList.map(t => t.amountRequested).reduce((acc, value) => acc + value, 0);
  }

  // account change
  accountChange($event) {
    if ($event) {
      this.getActivePendingContractsList();
    }
  }

  // Event fired on clearing selected account from dropdown
  clearAccount() {
    this.clearAllData();
  }

  // Search the account details on shipto / Deliverto dropdown
  accountSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.accountName.toLocaleLowerCase().indexOf(term) > -1
      || item.accountNumber.toString().indexOf(term) > -1
      || item.address1.toLocaleLowerCase().indexOf(term) > -1
      || item.city.toLocaleLowerCase().indexOf(term) > -1
      || item.state.toLocaleLowerCase().indexOf(term) > -1
      || item.zipCode.toLocaleLowerCase().indexOf(term) > -1;
  }

  // navigate to add new request page
  addPrePayRequest() {
    this.prePayService.accountNo = this.selectedAccount;
    this.router.navigate(['/new-prepay-request']);
  }
  // naviagate to contract information page
  navigateToContractInfo(obj: any) {
    if (obj.status === 'P') {
      const prepayContractData = {
        contractId: obj.contractNumber,
        contractType: obj.productSegment === '02' ? 'CPP' : 'SEED',// contractType,
        accountNo: obj.accountNumber,
        company: obj.companyCode,
        applyType: obj.autoPrepay,
        amount: obj.amountRequested,
        supplier: obj.supplier,
        contractDescription: obj.contractDescription
      };
      this.prePayService.setPrepayContractData(prepayContractData);
      this.router.navigate(['/edit-prepay-request']);
    } else {
      const contractType = obj.productSegment;// contractType.toLocaleUpperCase() === 'CPP' ? "02" : obj.contractType.toLocaleUpperCase() === 'SEED' ? "04" : "06 ";
      const prepayContractData = {
        contractId: obj.contractNumber,
        businessLine: contractType,
        userReserved: obj.supplier,
        accountNo: obj.accountNumber,
        cropYear: obj.cropYear,
        contractType: obj.productSegment === '02' ? 'CPP' : 'SEED',
        contractDescription: obj.contractDescription,
        currentBalance: obj.currentBalance,
        requestedAmount: obj.amountRequested,
        supplier: obj.supplier
      };
      this.prePayService.setPrepayContractData(prepayContractData);
      this.router.navigate(['/prepay-contract']);
    }
  }

  // Get Crop Year data
  getCropYearData() {
    this.subscription.push(this.prePayService.getCropYearData().subscribe((results: any) => {
      this.cropYearData = results;
    }));
  }

  exportResult(e) {
    this.loaderService.setLoaderStatus(true);
    const exportData = [];
    if (e.contractNumber) {
      const data = this.cropYearData.filter(t => t.cropYear === +e.cropYear);
      const fromDate = data[0].startDate;;
      const toDate = data[0].endDate;

      this.prePayService.getPrepayDetailData(e.contractNumber, e.productSegment, e.supplier, e.accountNumber, this.datePipe.transform(fromDate, 'MM-dd-yyyy'), this.datePipe.transform(toDate, 'MM-dd-yyyy')).subscribe((results: any) => {
        if (results) {
          this.loaderService.setLoaderStatus(true);
          if (results && results.length > 0) {
            results.forEach(x => {
              exportData.push({
                'CONTRACT NUMBER.': x.contractNumber,
                'SUPPLIER': x.supplier,
                'PARENT ACCOUNT NUMBER': x.parentAccountNumber,
                'ACCOUNT NUMBER': x.accountNumber,
                'SHIP TO ACCOUNT NUMBER': x.shipToAccountNumber,
                'ACCOUNT CITY': x.accountCity,
                'INVOICE DATE': this.datePipe.transform(x.invoiceDate, 'MM-dd-yyyy'),
                'INVOICE NUMBER': x.invoiceNumber,
                'DESCRIPTION': x.description,
                'STARTING BALANCE($)': { v: x.startingBalance, t: 'n', z: '#,##0.00', alignRight: true },
                'INVOICE AMOUNT($)': { v: x.invoiceAmount, t: 'n', z: '#,##0.00', alignRight: true },
                'ENDING BALANCE($)': { v: x.endingBalance, t: 'n', z: '#,##0.00', alignRight: true }
              });
            });
            this.excelService.exportAsExcelFile(exportData, 'Prepay_Contract');
          } else {
            this.toastrService.error('No data available for Agreement Number #' + e.contractNumber);
          }
          this.loaderService.setLoaderStatus(false);
        }
      }, error => {
        this.loaderService.setLoaderStatus(false);
      });
    }
  }

  clearAllData() {
    this.activePendingContractsList = [];
    this.closedContractsList = [];
    this.activePendingFooterContractsColumns = [];
    this.closedFooterContractsColumns = [];
    this.activePendingContractsDataSource = new MatTableDataSource([]);
    this.activePendingContractsDataSource.sort = this.activePendingContractsSort;
    this.activePendingContractsDataSource.paginator = this.activePendingContractsPaginator;
    this.closedContractsDataSource = new MatTableDataSource([]);
    this.closedContractsDataSource.sort = this.closedContractsSort;
    this.closedContractsDataSource.paginator = this.closedContractsPaginator;
  }

  // Cancel a contract request
  cancelContractrequest(obj: any) {
    if (obj) {
      const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '480px',
        data: { title: 'Cancel Request', message: 'Do you want to cancel request?', labelYes: 'Yes', labelNo: 'No', dialogType: 'confirm' }
      });

      this.subscription.push(dialogRef.afterClosed().subscribe(result => {
        // If user selected Yes
        if (result == true) {
          this.loaderService.setLoaderStatus(true);
          // console.log(obj);
          const data = {
            AccountNumber: obj.accountNumber,
            RequestType: 'C',
            ContractNumber: obj.contractNumber,
            AutoApply: obj.autoPrepay,
            DateSigned: this.datePipe.transform(new Date(), 'yyyy-MM-dd'),
            Description: obj.contractDescription,
            Amount: obj.amountRequested,
            Supplier: obj.supplier,
            BusinessLine: obj.productSegment,
            Company: obj.companyCode,
            UserID: ''
          };
          this.subscription.push(this.prePayService.cancelContractRequest(data).subscribe((result: any) => {
            if (result && result.status) {
              this.toastrService.success('Agreement Number #' + obj.contractNumber + ' contract request cancelled successfully.');
              this.getActivePendingContractsList();// (this.filter);
              this.loaderService.setLoaderStatus(false);
            } else {
              this.toastrService.error('Your prepay request failed, please call WinField United customer service at 855-494-6343');
              this.loaderService.setLoaderStatus(false);
            }
          }, error => {
            this.toastrService.error('Your prepay request failed, please call WinField United customer service at 855-494-6343');
            this.loaderService.setLoaderStatus(false);
          }));
        }
      }));
    }
  }

  // Function to add 2 decimal places to number and comma formatting
  numberWithCommas(x) {
    const parts = parseFloat(x).toFixed(2).toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }

  ngOnDestroy() {
    this.subscription.forEach(subscription => subscription.unsubscribe());

    this.prePayService.selectedAccount = undefined;
  }

  generatePdf(e) {
    this.loaderService.setLoaderStatus(true);
    if (e.contractNumber) {
      const data = this.cropYearData.filter(t => t.cropYear === +e.cropYear);
      const fromDate = data[0].startDate;;
      const toDate = data[0].endDate;
      this.prePayService.getPrepayDetailData(e.contractNumber, e.productSegment, e.supplier, e.accountNumber, this.datePipe.transform(fromDate, 'MM-dd-yyyy'), this.datePipe.transform(toDate, 'MM-dd-yyyy')).subscribe((results: any) => {
        if (results) {
          this.loaderService.setLoaderStatus(true);
          if (results && results.length > 0) {
            this.contractPdf = results;
            const documentDefinition = this.getDocumentDefinition();
            pdfMake.createPdf(documentDefinition).download('Prepay_Contract.pdf');
          } else {
            this.toastrService.error('No data available for Agreement Number #' + e.contractNumber);
          }
          this.loaderService.setLoaderStatus(false);
        }
      }, error => {
        this.loaderService.setLoaderStatus(false);
      });
    }
  }

  getDocumentDefinition() {
    const dt = new Date();
    const currDate = this.datePipe.transform(dt, 'MM-dd-yyyy');

    return {
      footer: function (currentPage, pageCount, pageSize) {
        return [
          {
            text: currDate, alignment: 'left', fontSize: 8, marginLeft: 45
          },
          {
            text: 'Page' + currentPage.toString() + ' of ' + pageCount, alignment: 'right', fontSize: 8, marginRight: 45
          },
        ];
      },
      content: [
        {
          text: 'Prepay Statement',
          bold: true,
          fontSize: 16,
          alignment: 'left',
          margin: [0, 0, 0, 20]
        },
        {
          image: 'data:image/png;base64,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',
          width: 120,
          height: 40,
          alignment: 'right',
        },
        {
          layout: 'noBorders',
          table: {
            body: [
              ['Supplier :', this.contractPdf[0].supplier],
              ['Selected Account Numbers :', this.contractPdf[0].accountNumber],
              ['Account Name :', this.contractPdf[0].accountName]
            ]
          },
          fontSize: 10,
          marginTop: 10
        },

        this.getContractPdfObject(this.contractPdf),

      ],
      styles: {
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 20, 0, 10],
          decoration: 'underline'
        },
        name: {
          fontSize: 16,
          bold: true
        },
        jobTitle: {
          fontSize: 14,
          bold: true,
          italics: true
        },
        sign: {
          margin: [0, 50, 0, 10],
          alignment: 'right',
          italics: true
        },
        tableHeader: {
          bold: true,
          fillColor: '#EBF1DE',
          fontSize: 7,
        },
        tablefont: {
          fontSize: 8,
          marginTop: 10
        }
      }
    };
  }

  getContractPdfObject(prepayDetails: PrepayDetailVM[]) {
    return {
      table: {
        widths: ['8.33%', '8.33%', '8.33%', '8.33%', '8.33%', '8.33%', '8.33%', '8.33%', '8.33%', '8.33%', '8.33%', '8.33%'],
        body: [
          [{
            text: 'CONTRACT NUMBER',
            style: 'tableHeader'
          },
          {
            text: 'SUPPLIER',
            style: 'tableHeader'
          },
          {
            text: 'PARENT ACCOUNT NUMBER',
            style: 'tableHeader'
          },
          {
            text: 'ACCOUNT NUMBER',
            style: 'tableHeader'
          },
          {
            text: 'SHIP TO ACCOUNT NUMBER',
            style: 'tableHeader'
          },
          {
            text: 'ACCOUNT CITY',
            style: 'tableHeader'
          },
          {
            text: 'INVOICE DATE',
            style: 'tableHeader'
          },
          {
            text: 'INVOICE NUMBER',
            style: 'tableHeader'
          },
          {
            text: 'DESCRIPTION',
            style: 'tableHeader'
          },
          {
            text: 'STARTING BALANCE($)',
            style: 'tableHeader'
          },
          {
            text: 'INVOICE AMOUNT($)',
            style: 'tableHeader'
          },
          {
            text: 'ENDING BALANCE($)',
            style: 'tableHeader'
          },
          ],
          ...prepayDetails.map(pd => [pd.contractNumber, pd.supplier, pd.parentAccountNumber, pd.accountNumber, pd.shipToAccountNumber, pd.accountCity, this.datePipe.transform(pd.invoiceDate, 'MM-dd-yyyy'), pd.invoiceNumber, pd.description, { text: this.numberWithCommas(pd.startingBalance), alignment: 'right' }, { text: this.numberWithCommas(pd.invoiceAmount), alignment: 'right' }, { text: this.numberWithCommas(pd.endingBalance), alignment: 'right' }])
        ]
      },
      style: 'tablefont',
    };
  }
}
